class ProductReplacementSearch {
  constructor(options) {
    // Use a hardcoded public access token - this should be your store's public token
    this.storefrontAccessToken = "296c383f2622e1d6d1a456e0aed1c335" // Replace this with your store's public access token
    this.shopDomain = window.Shopify.shop
    this.container = options.container
    this.skus = options.skus

    console.log("ProductReplacementSearch initialized with SKUs:", this.skus)
    this.init()
  }

  async init() {
    if (!this.skus || !this.skus.length) {
      console.log("No SKUs provided")
      return
    }

    try {
      const products = await this.searchProducts()
      console.log("Search results:", products)
      this.renderProducts(products)
    } catch (error) {
      console.error("Error searching for replacement products:", error)
      this.renderError()
    }
  }

  renderError() {
    this.container.innerHTML =
      '<p class="replacement-products__error">Unable to load replacement products. Please try again later.</p>'
  }

  async searchProducts() {
    const query = `
      query predictiveSearch($query: String!) {
        predictiveSearch(
          query: $query,
          searchableFields: VARIANTS_SKU,
          limit: 10,
        ) {
          products {
            id
            title
            handle
            featuredImage {
              url
              altText
            }
            variants(first: 1) {
              edges {
                node {
                  sku
                  price {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      }
    `

    // Create a SKU filter query - for predictiveSearch we don't need the "sku:" prefix
    const skuQuery = this.skus
      .map((sku) => {
        // Split on '?' and take only the first part, then trim whitespace
        return sku.split("?")[0].trim()
      })
      .join(" OR ")
    console.log("Search query:", skuQuery)

    try {
      console.log(
        "Making API request to:",
        `https://${this.shopDomain}/api/2025-01/graphql.json`
      )
      const response = await fetch(
        `https://${this.shopDomain}/api/2025-01/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": this.storefrontAccessToken,
          },
          body: JSON.stringify({
            query: query,
            variables: {
              query: skuQuery,
            },
          }),
        }
      )

      if (!response.ok) {
        console.error("Response not OK:", response.status, response.statusText)
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      console.log("API Response:", data)

      if (data.errors) {
        console.error("GraphQL Errors:", data.errors)
        throw new Error(data.errors[0].message)
      }

      return data.data.predictiveSearch.products
    } catch (error) {
      console.error("API Error:", error)
      throw error
    }
  }

  renderProducts(products) {
    if (!products || !products.length) {
      return
    }

    const productList = document.createElement("div")
    productList.className = "replacement-products return-policy-block"

    const headingContainer = document.createElement("div")
    headingContainer.className = "return-policy-header"

    // Add the SVG icon
    const icon = document.createElement("div")
    icon.innerHTML = `
      <svg
        class="icon icon-replacement icon-replacement-black"
        width="26"
        height="26"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill-rule="evenodd" d="M13.324 3.5h.852c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.168.598.435.765.765.118.23.157.463.175.676.016.198.016.434.016.692v.852c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.676 1.75 1.75 0 0 1-.765.765 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016h-.852c-.258 0-.494 0-.692-.016a1.774 1.774 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.775 1.775 0 0 1-.175-.676c-.016-.198-.016-.434-.016-.692v-.852c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .764-.765c.23-.118.464-.157.677-.175.198-.016.434-.016.692-.016Zm-.693 1.53h.001Zm.002-.001a.626.626 0 0 1 .121-.018c.13-.01.304-.011.596-.011h.8c.292 0 .467 0 .596.011a.626.626 0 0 1 .12.018.25.25 0 0 1 .105.104.638.638 0 0 1 .018.121c.01.13.011.304.011.596v.8c0 .292 0 .467-.011.596a.638.638 0 0 1-.018.12.25.25 0 0 1-.104.105.626.626 0 0 1-.121.018c-.13.01-.304.011-.596.011h-.8c-.292 0-.467 0-.596-.011a.626.626 0 0 1-.12-.018.25.25 0 0 1-.105-.104.638.638 0 0 1-.018-.121 8.374 8.374 0 0 1-.011-.596v-.8c0-.292 0-.467.011-.596a.638.638 0 0 1 .018-.12.25.25 0 0 1 .104-.105Zm-.103.102v.001Zm0 2.238v-.001Zm.1.101h.002Zm2.24 0h-.002Zm.1-.1v-.002Zm0-2.24v.002Zm-.102-.1h.001Z"/><path fill-rule="evenodd" d="M6.676 16.5h-.852c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676c-.016-.198-.016-.434-.016-.692v-.852c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765c.23-.118.463-.158.676-.175.198-.016.434-.016.692-.016h.852c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.167.597.435.765.764.118.23.157.464.175.677.016.198.016.434.016.692v.852c0 .258 0 .494-.016.692a1.774 1.774 0 0 1-.175.676 1.75 1.75 0 0 1-.765.765 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016Zm.693-1.53h-.001Zm-.002.001a.638.638 0 0 1-.121.018c-.13.01-.304.011-.596.011h-.8c-.292 0-.467 0-.596-.011a.638.638 0 0 1-.12-.018.25.25 0 0 1-.105-.104.626.626 0 0 1-.018-.121 8.337 8.337 0 0 1-.011-.596v-.8c0-.292 0-.467.011-.596a.626.626 0 0 1 .018-.12.25.25 0 0 1 .104-.105.638.638 0 0 1 .121-.018c.13-.01.304-.011.596-.011h.8c.292 0 .467 0 .596.011a.638.638 0 0 1 .12.018.25.25 0 0 1 .105.104.626.626 0 0 1 .018.121c.01.13.011.304.011.596v.8c0 .292 0 .467-.011.596a.626.626 0 0 1-.018.12.25.25 0 0 1-.104.105Zm.103-.102v-.001Zm0-2.238v.001Zm-.1-.101h-.002Zm-2.24 0h.002Zm-.1.1v.002Zm0 2.24v-.002Zm.102.1h-.001Z"/><path d="M6.97 4.53a.75.75 0 1 1 1.06-1.06l1.995 1.994a.758.758 0 0 1 .225.536v.007a.75.75 0 0 1-.22.523l-2 2a.75.75 0 0 1-1.06-1.06l.72-.72h-.24c-.572 0-.957 0-1.253.025-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.3a.75.75 0 0 1-1.5 0v-.33c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073a2.75 2.75 0 0 1 1.202-1.202c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03h.27l-.72-.72Z"/><path d="M13.803 13.225c-.296.024-.68.025-1.253.025h-.24l.72-.72a.75.75 0 0 0-1.06-1.06l-2 2a.748.748 0 0 0 .005 1.066l1.995 1.994a.75.75 0 1 0 1.06-1.06l-.72-.72h.27c.535 0 .98 0 1.345-.03.38-.03.736-.098 1.073-.27a2.751 2.751 0 0 0 1.202-1.201c.172-.338.24-.694.27-1.074.03-.365.03-.81.03-1.345v-.33a.75.75 0 0 0-1.5 0v.3c0 .572 0 .957-.025 1.252-.023.288-.065.425-.111.516a1.25 1.25 0 0 1-.546.546c-.091.046-.228.088-.515.111Z"/>
      </svg>
    `

    headingContainer.appendChild(icon.firstElementChild)

    const heading = document.createElement("h3")
    heading.textContent = "Substitute Products"

    headingContainer.appendChild(heading)
    productList.appendChild(headingContainer)

    const list = document.createElement("ul")
    list.className = "replacement-products__list"

    products.forEach((product) => {
      const li = document.createElement("li")
      const link = document.createElement("a")
      link.href = `/products/${product.handle}`
      link.className = "replacement-item"
      link.target = "_blank"

      // Create image wrapper and image
      const imageWrapper = document.createElement("div")
      imageWrapper.className = "replacement-item__image-wrapper"

      if (product.featuredImage) {
        const image = document.createElement("img")
        image.src = product.featuredImage.url
        image.alt = product.featuredImage.altText || product.title
        image.className = "replacement-item__image"
        image.width = 48
        image.height = 48
        image.loading = "lazy"
        imageWrapper.appendChild(image)
      }
      link.appendChild(imageWrapper)

      // Create content wrapper for title and price
      const content = document.createElement("div")
      content.className = "replacement-item__content"

      // Create title
      const title = document.createElement("span")
      title.className = "replacement-item__title"
      title.textContent = product.title
      content.appendChild(title)

      // Create price display
      const priceWrapper = document.createElement("div")
      priceWrapper.className = "replacement-item__price"

      const variant = product.variants.edges[0]?.node
      if (variant) {
        const formatPrice = (price) => {
          if (!price || !price.amount) return ""
          return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: price.currencyCode,
          }).format(price.amount)
        }

        if (
          variant.compareAtPrice &&
          variant.compareAtPrice.amount &&
          parseFloat(variant.compareAtPrice.amount) >
            parseFloat(variant.price.amount)
        ) {
          const comparePrice = document.createElement("span")
          comparePrice.className =
            "replacement-item__compare-price price-item price-item--regular"
          comparePrice.textContent = formatPrice(variant.compareAtPrice)
          priceWrapper.appendChild(comparePrice)
        }

        const price = document.createElement("span")
        price.className =
          "replacement-item__sale-price price-item price-item--last"
        price.textContent = formatPrice(variant.price)
        priceWrapper.appendChild(price)
      }

      content.appendChild(priceWrapper)
      link.appendChild(content)

      li.appendChild(link)
      list.appendChild(li)
    })

    productList.appendChild(list)
    this.container.innerHTML = ""
    this.container.appendChild(productList)
  }
}

customElements.define(
  "product-replacement-search",
  class extends HTMLElement {
    constructor() {
      super()
      this.replacementSkus = this.dataset.skus?.split(",") || []

      if (this.replacementSkus.length) {
        new ProductReplacementSearch({
          container: this,
          skus: this.replacementSkus,
        })
      }
    }
  }
)
